import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import type { DrawerProps } from 'antd';
// eslint-disable-next-line no-restricted-imports
import { Drawer as AntDrawer } from 'antd';
import * as React from 'react';
import { useId } from 'react';

export interface IDrawerProps extends DrawerProps {
  title: React.ReactNode;
}

/**
 * Drawer modificato per supportare gli attributi ARIA
 */
export function Drawer(props: IDrawerProps) {
  const { title, ...otherProps } = props;
  const { t } = useTranslation();
  const titleId = useId();

  const closeIconRef = React.useRef<HTMLSpanElement>(null);

  return (
    <AntDrawer
      afterOpenChange={open => {
        if (!open) return;

        const buttonElement = closeIconRef.current?.parentElement;
        if (!buttonElement) return;

        try {
          buttonElement?.setAttribute(
            'aria-label',
            t('drawer.close-aria', 'Chiudi Pannello'),
          );
          buttonElement.focus?.();
          closeIconRef.current?.removeAttribute('aria-label');
        } catch (e) {
          console.info('Errore durante la rimozione dell\'aria-label dal pulsante di chiusura del Drawer', e); // prettier-ignore
        }
      }}
      aria-labelledby={titleId}
      closeIcon={<CloseOutlined ref={closeIconRef} aria-hidden />}
      title={<div id={titleId}>{title}</div>}
      {...otherProps}
    />
  );
}
